import { render } from "./UltraCard.vue?vue&type=template&id=89c05e1e&scoped=true"
import script from "./UltraCard.vue?vue&type=script&lang=js"
export * from "./UltraCard.vue?vue&type=script&lang=js"

import "./UltraCard.vue?vue&type=style&index=0&id=89c05e1e&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c05e1e"]])

export default __exports__